function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgDiabetes = function SvgDiabetes(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M10.087 15.158a3.7 3.7 0 0 1-1.439-.91A3.7 3.7 0 0 1 7.62 12.11"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M10.358 17.274a3.85 3.85 0 0 0 1.768-.528c.74-.435 1.338-1.012 1.762-1.758.224-.396.344-.832.437-1.276.132-.63.088-1.25-.06-1.872-.219-.925-.58-1.796-.945-2.668-.561-1.336-3.404-6.464-3.404-6.464S7.09 7.837 6.528 9.173c-.366.872-.726 1.743-.945 2.668-.148.623-.192 1.242-.06 1.872.093.444.212.88.437 1.276.424.746 1.022 1.323 1.762 1.758.548.322 1.14.494 1.768.528z"
  }));
};
export default SvgDiabetes;